module.exports = __webpack_public_path__ + "static/media/umbrella.c95bd9a9.svg";